import { FilterHandler, useFilter } from '@btime/react-contexts'
import React from 'react'

import { Grid } from '../../packages/kiti/components/structure/Grid'
import { useEffectAfterMount } from '../../packages/kiti/utils/helpers/effectAfterMount'

const Content = ({ filtersList, onChange, ...props }) => {
  const filter = useFilter()

  useEffectAfterMount(() => {
    onChange(filter)
  }, [filter])

  return (
    <Grid align="center" wrap gap={1} {...props}>
      {filtersList}
    </Grid>
  )
}

const Wrapper = ({ value, ...props }) => {
  return (
    <FilterHandler initialState={{ filter: value }}>
      <Content {...props} />
    </FilterHandler>
  )
}

export default Wrapper
